import { actionTypes } from '../../../types';

const initialState = {
    loading: false,
    error: '',
    status: null,
    response: {},
    message: '',
};

const deactivateAccountReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.DEACTIVATE_ACCOUNT_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
                status: null,
                response: {},
                message: '',
            };
        case actionTypes.DEACTIVATE_ACCOUNT_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action.payload.status,
                response: action.payload.response,
                message: action.payload.message,
            };
        case actionTypes.DEACTIVATE_ACCOUNT_FAILURE:
            return {
                ...state,
                loading: false,
                status: action.payload.status,
                message: action.payload.message,
                error: action.payload.message || 'Something went wrong',
            };
        case actionTypes.DEACTIVATE_ACCOUNT_RESET:
            return initialState;
        default:
            return state;
    }
};

export default deactivateAccountReducer;
